import React, {Component} from 'react';
import {connect} from 'react-redux';
import {pushEdapEvent} from '../../../utils/edap';
import {addListener} from '../../../utils/scroll';
import './arrow-mobile.svg';
import './arrow-desktop.svg';

export const mapStateToProps = (state) => ({
    translation: state.modules.backToTopText
});
export class BackToTopButton extends Component {
    constructor(props) {
        super(props);
        this.state = {
            displayBackToTopButton: false,
            scrollingInterval: 0
        };
    }

    componentDidMount() {
        const jumbotronHeight = document.querySelector('.jumbotron').clientHeight;
        addListener(this.scrollHandler.bind(this, jumbotronHeight));
    }

    scrollAnimation(distance) {
        if (window.pageYOffset === 0) {
            clearInterval(this.state.scrollingInterval);
        }
        scrollBy(0, -distance);
    }
    scrollToTop = () => {
        const ANIMATION_TIME = 600;
        const INTERVAL_TIME = 10;
        const MINIMUM_DISTANCE = 90;
        const distancePerInterval = Math.max(window.pageYOffset / (ANIMATION_TIME / INTERVAL_TIME), MINIMUM_DISTANCE);

        let scrollingInterval = setInterval(this.scrollAnimation.bind(this, distancePerInterval), INTERVAL_TIME);
        this.setState({scrollingInterval});

        pushEdapEvent('generic.event', {
            actionlocation: 'back-to-top',
            eventcategory: 'back-to-top',
            eventaction: 'button-clicked'
        });
    }

    scrollHandler = (jumbotronTop) => {
        this.setState({
            displayBackToTopButton: (window.pageYOffset > jumbotronTop)
        });
    }

    render() {
        const {
            translation
        } = this.props;

        const button = (<button onClick={this.scrollToTop} className="backtotop__button btn btn-primary" >
            <span>{translation}</span>
        </button>);

        return translation && this.state.displayBackToTopButton ?
            button : null;
    }
}

export const BackToTopComponent = connect(mapStateToProps)(BackToTopButton);

export default BackToTopComponent;
